import React, { useState, Fragment, useEffect } from "react"
import PropTypes from "prop-types"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Progress,
  Button,
} from "reactstrap"
import { Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import moment from "common/moment_i18n"
import XlsExporter from "components/Common/XlsExporter"

import {
  listGroupCourses,
  addGroupCourse,
  addGroupCourseClean,
  removeGroupCourse,
  removeGroupCourseClean,
  getCourses,
  resetGroupCourse,
  resetGroupCourseClean,
  getLevels,
  listGroupParticipants,
  getUsers,
} from "../../store/actions"
import "../../assets/scss/datatables.scss"
import { useDispatch, useSelector } from "react-redux"
import AddCourseToGroupModal from "./AddCourseToGroupModal"
import DeleteCourseFromGroupModal from "./DeleteCourseFromGroupModal"
import CoursePreviewModal from "./CoursePreviewModal"

const CoursesGroupListTable = props => {
  const dispatch = useDispatch()
  const { SearchBar } = Search

  const [dropDown, setDropDown] = useState(0)
  const [showAddCourse, setShowAddCourse] = useState(false)
  const [showDeleteCourse, setShowDeleteCourse] = useState(undefined)
  const [coursePreview, setCoursePreview] = useState(undefined)
  const [courseToReset, setCourseToReset] = useState(undefined)
  const [page, setPage] = useState(undefined)
  const [sizePerPage, setSizePerPage] = useState(undefined)

  const idGroup = props.group.idGrupo ?? 0
  const groupName = props.group.nombreGrupo ?? ""

  useEffect(() => {
    dispatch(listGroupCourses(idGroup))
    dispatch(listGroupParticipants(idGroup))
    dispatch(getCourses())
    dispatch(getLevels())
    dispatch(getUsers())
  }, [idGroup])

  const {
    groupCourses,
    addCourseLoading,
    addCourseError,
    addCourseDone,
    removeCourseLoading,
    removeCourseError,
    removeCourseDone,
    resetCourseLoading,
    resetCourseError,
    resetCourseDone,
    coursesList,
    levels,
    groupParticipants,
    usersList,
  } = useSelector(store => ({
    groupCourses: store.GroupCoursesList.groupCourses,
    addCourseLoading: store.GroupCourseAdd.loading,
    addCourseError: store.GroupCourseAdd.error,
    addCourseDone: store.GroupCourseAdd.done,
    removeCourseLoading: store.GroupCourseRemove.loading,
    removeCourseError: store.GroupCourseRemove.error,
    removeCourseDone: store.GroupCourseRemove.done,
    resetCourseLoading: store.GroupCourseReset.loading,
    resetCourseError: store.GroupCourseReset.error,
    resetCourseDone: store.GroupCourseReset.done,
    coursesList: store.CoursesList.coursesManagement,
    levels: store.LevelsList.levels,
    groupParticipants: store.GroupParticipantsList.groupParticipants,
    usersList: store.UsersList.users,
  }))

  let courses = []
  let availableCourses = []

  if (Array.isArray(coursesList) && Array.isArray(groupCourses)) {
    coursesList.forEach(course => {
      const enriched = { ...course, courseCode: parseInt(course.courseCode) }
      if (enriched.status === 2) {
        const exists = groupCourses.find(
          groupCourse => groupCourse.idCourse === enriched.courseId
        )
        if (exists !== undefined) {
          courses.push({ ...enriched, groupUserPercentage: exists.groupUserPercentage })
        } else {
          availableCourses.push(enriched)
        }
      }
    })
  }

  let users = []

  if (Array.isArray(usersList) && Array.isArray(groupParticipants)) {
    usersList.forEach(user => {
      if (user.idStatus) {
        const exists = groupParticipants.find(
          participant => participant.idUser === user.idUsuario
        )
        if (exists !== undefined) {
          users.push({
            ...user,
            groupUserPercentage: exists.groupUserPercentage,
            completeCourses: exists.completeCourses,
            totalCourses: exists.totalCourses,
          })
        }
      }
    })
  }

  const dropDownActions = (cell, row, rowIndex, extraData) => {
    const active = extraData?.active ?? 0
    return (
      <Dropdown
        key={`dropdown-${row.courseId}`}
        isOpen={row.courseId === active}
        toggle={() => {
          setDropDown(row.courseId === active ? 0 : row.courseId)
        }}
      >
        <DropdownToggle color="primary" className="btn btn-primary btn-md">
          Acciones <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="white-celf-background">
          <DropdownItem onClick={() => setCoursePreview(row.courseId)}>
            Ver curso
          </DropdownItem>
          <DropdownItem onClick={() => setCourseToReset(row.courseId)}>
            Resetear curso
          </DropdownItem>
          <DropdownItem onClick={() => setShowDeleteCourse(row)}>
            Eliminar del grupo
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }

  console.log(courses)

  const columns = [
    {
      dataField: "courseId",
      text: "Id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "courseCode",
      text: "ID curso Henkel",
      sort: true,
    },
    {
      dataField: "courseName",
      text: "Nombre del curso",
      sort: true,
    },
    {
      dataField: "categoria",
      text: "Categoría(s) de conocimiento",
      sort: false,
      // eslint-disable-next-line react/display-name
      formatter: (column, row) => {
        let knowledgeCategories = []
        row.knowledgeCategories.forEach(object => {
          knowledgeCategories.push(object.knowledgeCategoryName)
        })
        let string = knowledgeCategories.join(", ")
        return (
          <div key={`knowledge-categories-${row.courseId}`}>
            {string === ""
              ? "-- Sin categorías de conocimiento asignadas --"
              : string}
          </div>
        )
      },
    },
    {
      dataField: "lastActivity",
      text: "Último ingreso",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (column, row) => {
        return (
          <span key={`time-${row.courseId}`}>
            {moment(row.lastActivity)
              .locale("es")
              .format("D [de] MMM [de] YYYY")}
          </span>
        )
      },
    },
    {
      dataField: "groupUserPercentage",
      text: "Avance grupal",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (column, row) => {
        return (
          <div key={`progress-course-${row.courseId}`}>
            <div className="mb-1 text-center">{`${Math.round(
              row.groupUserPercentage
            )}%`}</div>
            <Progress multi>
              <Progress
                bar
                value={row.groupUserPercentage}
                color="secondary"
                style={{ width: `${row.groupUserPercentage}%` }}
                animated
              ></Progress>
              <Progress
                bar
                value={100 - row.groupUserPercentage}
                color="light"
                style={{ width: `${100 - row.groupUserPercentage}%` }}
              ></Progress>
            </Progress>
          </div>
        )
      },
    },
    {
      dataField: "actions",
      text: "Acciones",
      sort: false,
      formatter: dropDownActions,
      formatExtraData: {
        active: dropDown,
      },
    },
  ]

  const pageOptions = {
    sizePerPage: sizePerPage === undefined ? 10 : sizePerPage,
    totalSize: courses?.length,
    custom: true,
    showTotal: true,
    page: page === undefined ? 1 : page,
    onPageChange: page => {
      setPage(page)
    },
    onSizePerPageChange: sizePerPage => {
      setSizePerPage(sizePerPage)
    },
  }

  const defaultSorted = [{ dataField: "claveCurso", order: "asc" }]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
  }

  const handleAddCourse = courseId => {
    const request = {
      idGroup: props.group.idGrupo,
      idCourse: courseId,
    }

    dispatch(addGroupCourse(request))
  }

  const handleDeleteCourse = courseId => {
    const request = {
      idGroup: props.group.idGrupo,
      idCourse: courseId,
    }

    dispatch(removeGroupCourse(request))
  }

  const handleResetCourse = () => {
    dispatch(
      resetGroupCourse({
        idGroup: idGroup,
        idCourse: courseToReset,
      })
    )
    setCourseToReset(undefined)
  }

  const getXlsData = courses => {
    let data = courses.map((element, index) => {
      const nivelCurso = levels.find(
        level => level.idLevel === element.courseLevelId
      )?.level
      return {
        "Nombre del grupo": groupName,
        "Nombre del curso": element.courseName,
        "% avance": element.groupUserPercentage,
        "Nivel del curso": nivelCurso,
        "Núm de participantes": users.length,
      }
    })

    return {
      Cursos: data,
    }
  }

  if (addCourseDone) {
    dispatch(listGroupCourses(props.group.idGrupo))
    dispatch(addGroupCourseClean())
  }

  if (removeCourseDone) {
    setShowDeleteCourse(undefined)
    dispatch(listGroupCourses(props.group.idGrupo))
    dispatch(removeGroupCourseClean())
  }

  return (
    <Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="courseId"
        columns={columns}
        data={courses}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="courseId"
            columns={columns}
            data={courses}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <Row>
                  <Col className="text-center">
                    <XlsExporter
                      classNames={`btn btn-link`}
                      data={getXlsData(courses)}
                      dataName={"Cursos"}
                      name="Cursos"
                      label="Exportar a Excel"
                    />
                    {"   "}
                    <Link to="/courses" className="btn btn-link">
                      <i className="fa fa-users"></i> Ver todos los cursos
                    </Link>
                  </Col>
                </Row>
                <Row className="mb-2 pt-3">
                  <Col xl={2} lg={3} md={4} sm={4} xs={6}>
                    <div className="d-grid">
                      <button
                        onClick={() => setShowAddCourse(true)}
                        className="btn btn-primary btn-rounded"
                      >
                        <i className="fa fa-plus"></i> Agregar curso
                      </button>
                    </div>
                  </Col>
                  <Col xl={8} lg={6} md={4} xs={0} className="text-center pt-2">
                    Total de cursos: <strong>{courses.length}</strong>
                  </Col>
                  <Col
                    xl={{ size: 2 }}
                    lg={{ size: 3 }}
                    md={{ size: 4 }}
                    sm={{ size: 4 }}
                    xs={6}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Buscar"
                          onSearch={value => {
                            setPage(1)
                            toolkitProps.searchProps.onSearch(value)
                          }}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <Fragment>
                        <BootstrapTable
                          keyField={"courseId"}
                          bordered={false}
                          striped={true}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                        {courses.length <= 0 && (
                          <Row>
                            <Col md={12} className="text-center">
                              -- No hay registros --
                            </Col>
                          </Row>
                        )}
                      </Fragment>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>

      <AddCourseToGroupModal
        show={showAddCourse}
        loading={addCourseLoading}
        courses={availableCourses}
        onConfirm={courseId => handleAddCourse(courseId)}
        onCancel={() => setShowAddCourse(false)}
        error={addCourseError}
      />
      <DeleteCourseFromGroupModal
        show={showDeleteCourse !== undefined}
        course={showDeleteCourse}
        loading={removeCourseLoading}
        onConfirm={courseId => handleDeleteCourse(courseId)}
        onCancel={() => setShowDeleteCourse(undefined)}
        error={removeCourseError}
      />
      <CoursePreviewModal
        show={coursePreview !== undefined}
        course={coursePreview}
        onClose={() => setCoursePreview(undefined)}
      />
      {courseToReset !== undefined && (
        <SweetAlert
          title="Resetear curso"
          warning
          confirmBtnBsStyle="secondary"
          cancelBtnBsStyle="light"
          showCancel={true}
          cancelBtnText="No, cancelar"
          confirmBtnText="Sí, resetear"
          onCancel={() => {
            setCourseToReset(undefined)
          }}
          onConfirm={handleResetCourse}
        >
          <p>¿Confirma que desea resetear este curso?</p>
        </SweetAlert>
      )}
      {resetCourseDone && (
        <SweetAlert
          title="Curso reseteado"
          success
          confirmBtnBsStyle="secondary"
          confirmBtnText="Aceptar"
          onConfirm={() => {
            dispatch(listGroupCourses(idGroup))
            dispatch(resetGroupCourseClean())
          }}
        >
          <p>Se reseteó el curso para el grupo exitosamente.</p>
        </SweetAlert>
      )}
    </Fragment>
  )
}

CoursesGroupListTable.propTypes = {
  group: PropTypes.object,
}

export default CoursesGroupListTable
